import React from "react"
import styled from "styled-components"

let StyledSaasView = styled.div`
  &.cls-saas-view-wrapper {
    background: #fff;
    color: #000;
    display: flex;
    width: 100%;
    min-height: 50px;
    flex-direction: row;
    padding: 8px;
    cursor: pointer;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
  }
  .cls-saas-view-text {
    text-align: left;
  }
  &:hover {
    background: #cfcfcf;
  }
  &.active {
    background: var(--lightColor);
    color: #fff;
    pointer-events: none;
    font-weight: bold;
  }
  .cls-saas-view-badge {
    font-size: 11px;
    color: #ffffff;
    font-weight: bold;
    background: #93d399;
    width: fit-content;
    border-radius: 4px;
    width: 70px;
    height: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-transform: upperCase;
  }
  .cls-saas-view-text {
    width: calc(100% - 120px);
    text-wrap: auto;
    word-wrap: break-word;
  }
`
function SaasView({
  value = "",
  dataItem = {},
  getSelectRowItem,
  onUpdateSelectRowItem = () => "",
}) {
  const { is_active = false } = dataItem
  const { type = "" } = dataItem
  return (
    <StyledSaasView
      className={`cls-saas-view-wrapper ${
        getSelectRowItem === value ? "active" : ""
      }`}
      onClick={() => onUpdateSelectRowItem({ value, type, dataItem })}
    >
      <div className="cls-saas-view-text">{`${value}`}</div>
      <div className="cls-saas-view-badge">
        <div>{`${type}`}</div>
      </div>
    </StyledSaasView>
  )
}

export default SaasView
export { SaasView }
